export const OverdriveKey = {
  background: (category, box) => `${box}/background`,
  image: (category, box) => `${box}/image`,
  description: (category, box) => `${box}/description`
};
